export const SELECTORS = {
  REVIEW: 'js-review',
  SLIDER: 'js-review-photo-card-slider',
  NAME: 'js-review-name',
  LOCATION: 'js-review-location',
  COMMENT: 'js-review-comment',
  DATE: 'js-review-date',
  PHOTOS: 'js-review-photos',
  ACTIONS: 'js-review-actions',
  REPLY: 'js-review-reply',
  REPLY_COMMENT: 'js-review-reply-comment',
  REPLY_SHOW_MORE: 'js-review-reply-show-more'
};
